// extracted by mini-css-extract-plugin
export default {"avatar":"Avatars_avatar__rIArU","hideMobile":"Avatars_hideMobile__MVur6"};